// extracted by mini-css-extract-plugin
export default {"tabContainer":"burgerTab_tabContainer__eV8Zt"};